import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function getAdminUserOtherProjectreducer(state = initialState.adminUserOtherProject, action) {
	switch (action.type) {
		case types.GET_ADMIN_USER_OTHER_PROJECT: {
			return action.response;
		}
		case types.CLEAR_ADMIN_USER: {
			return initialState.adminUserOtherProject;
		}
		default:
			return state;
	}
}
